import { render, staticRenderFns } from "./BarNorm.vue?vue&type=template&id=18cffce0&scoped=true&"
import script from "./BarNorm.vue?vue&type=script&lang=ts&"
export * from "./BarNorm.vue?vue&type=script&lang=ts&"
import style0 from "./BarNorm.vue?vue&type=style&index=0&id=18cffce0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cffce0",
  null
  
)

export default component.exports